import styled, { css, keyframes } from 'styled-components';
import type { WithSX } from '@elfsight/lib-utils';
import { applySX } from '@elfsight/lib-utils';

interface SkeletonProps {
  width: number | string;
  height: number | string;
  className?: string;
  borderRadius?: number | string;
  color?: string;
  animated?: boolean;
}

export function Skeleton({
  width,
  height,
  className,
  borderRadius = 4,
  color: loaderColor = 'rgb(210, 210, 210)',
  animated = true
}: SkeletonProps) {
  return (
    <StyledSkeleton
      className={className}
      $animated={animated}
      $sx={{
        width,
        height,
        borderRadius,
        backgroundColor: loaderColor
      }}
    />
  );
}

const blinker = keyframes`
  from {
    opacity: 0.4;
  }
  to {
    opacity: 1;
  }
`;

const prefersReducedMotion = '@media (prefers-reduced-motion: reduce)';

const StyledSkeleton = styled.div<WithSX & { $animated: boolean }>`
  ${applySX};
  opacity: 0.4;
  ${({ $animated }) =>
    $animated &&
    css`
      animation: ${blinker} 1.5s ease-in-out infinite alternate;
    `}
  ${prefersReducedMotion} {
    animation: none;
  }
`;
